<template>
  <div>
    <div v-if="error">
      <error404
        msg="Nenhum Associado Encontrado"
        urlBack="/Associados"
      ></error404>
    </div>
    <div v-else>
      <vx-card>
        <div class="mt-5" v-if="dadosAssociado != {}">
          <h3 class="mb-6">Beneficiário {{ dadosAssociado.idProspect }}</h3>
          <div class="text-right">
            <router-link :to="`/detalheAssociado/${dadosAssociado.idProspect}`">
              <vs-button color="dark" type="gradient" class="mr-3 mb-2"
                ><vs-icon icon="search" class="mr-3"></vs-icon>
                Detalhe do Beneficiário
              </vs-button>
            </router-link>
            <vs-button
              v-if="permissaoHistoricoAlteracoes"
              color="primary"
              @click="abrirModalHistorico(dadosAssociado)"
              ><vs-icon icon="list" class="mr-3"></vs-icon>Histórico
              Alterações</vs-button
            >
          </div>
          <formulario
            :formulario="form"
            :dadosAssociado="dadosAssociado"
            @formAlterado="alteraFormPai(1, $event)"
            :regionais="regionais"
          ></formulario>
        </div>
      </vx-card>
      <div class="vx-row mt-3">
        <div class="vx-col w-full text-right">
          <form role="form" @submit.stop.prevent="onSubmit">
            <BotaoSubmit
              v-if="$can('Escrita', 'Associados')"
              variant="success"
              :edit="true"
              :aguarde="aguardeCadastro"
            ></BotaoSubmit>
          </form>
        </div>
      </div>
    </div>
    <ModalHistorico
      :popupActive="popupActive"
      :tipo="tipoHistorico"
      :nome="nomeHistorico"
      :dadosConsulta="dadosConsultaHistorico"
      @close="fecharModal"
    ></ModalHistorico>
  </div>
</template>

<script>
import service from './../../services';
import locale from './../../locale';
import BotaoSubmit from '../../components/BotaoSubmit';
import formulario from './../forms/formAssociado';
import error404 from './../pages/Error404.vue';
import jwt from 'jsonwebtoken';
import cpfCnpj from '../../services/cpfCnpj';
import ModalHistorico from '../modais/ModalHistoricoAlteracoes.vue';
import { decryptData } from './../../services/decryptData';

export default {
  components: {
    BotaoSubmit,
    formulario,
    error404,
    ModalHistorico,
  },
  watch: {
    aceiteUnificacao() {
      if (this.aceiteUnificacao) {
        this.onSubmit();
      }
    },
  },
  data() {
    return {
      modalProdutos: true,
      idAssociadoUnificar: null,
      cpfDuplicado: false,
      aguardeCadastro: false,
      dadosAssociado: {},
      regionais: [],
      error: false,
      status: [],
      idEmpresa: null,
      formUnificacao: {},
      form: {
        dadosGerais: {},
        dadosCliente: {},
        dadosVeiculo: {},
        dadosProduto: {},
      },
      passo: 0,
      aceiteUnificacao: null,
      popupActive: false,
      tipoHistorico: 'Associado',
      nomeHistorico: '',
      dadosConsultaHistorico: [],
    };
  },
  computed: {
    permissaoHistoricoAlteracoes() {
      return this.$can('Historico Alterações', 'Associados');
    },
  },
  methods: {
    onSubmit() {
      this.form.dadosAssociado = this.dadosAssociado;
      {
        this.aguardeCadastro = true;
        if (this.form.dadosCliente.validate || this.aceiteUnificacao) {
          if (
            cpfCnpj.valida_cpf_cnpj(this.form.dadosCliente.cpfcnpj) == false
          ) {
            this.aguardeCadastro = false;
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Este CPF ou CNPJ não é válido`,
              color: 'danger',
            });
            return;
          }
          if (
            !this.form.dadosCliente.cpfDuplicado ||
            this.form.dadosCliente.unificaAssociado
          ) {
            this.$vs.loading();
            this.aguardeCadastro = true;
            service
              .post('Associado', 'AtualizarGeral', this.form)
              .then(() => {
                this.aguardeCadastro = false;
                this.$vs.loading.close();
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: `Operação Realizada com sucesso`,
                  color: 'success',
                });
                /*if (this.aceiteUnificacao) {
                  this.unificarAssociados();
                  window.location.href = '/Associados';
                }*/
                this.$emit('concluido');
                this.buscaDados();
              })
              .catch((error) => {
                this.aguardeCadastro = false;
                this.$vs.loading.close();
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: error,
                  color: 'danger',
                });
              });
          } else {
            this.$vs.loading.close();
            this.aguardeCadastro = false;
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Unifique o cadastro ou digite um novo CPF',
              color: 'danger',
            });
          }
        } else {
          this.aguardeCadastro = false;
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Confira os campos obrigatórios',
            color: 'danger',
          });
        }
      }
    },
    atualizaBotao() {
      setTimeout(() => {
        this.precisaAlterarProduto = false;
      }, 400);
    },
    alteraFormPai(passo, valoresForm) {
      if (valoresForm.unificaAssociado) {
        this.aceiteUnificacao = valoresForm.unificaAssociado;
      }
      if (passo == 1) this.form.dadosCliente = valoresForm;
    },

    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idProspect = this.$route.params.idAssociado;
      service
        .getAll('Associado', {}, 'list/' + objSend.idProspect)
        .then((res) => {
          if (res.data.length > 0) {
            if (res.data[0].idEmpresa != this.idEmpresa) this.error = true;
            this.dadosAssociado = res.data[0];
            //this.preencheForm();
            this.$vs.loading.close();
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Você não tem acesso a visualização desta Proposta/Vistoria',
              color: 'danger',
            });
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        this.idEmpresa = decoded.id_empresa;
      }
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=null`)
        .then((res) => {
          res.data = decryptData(res.data);
          this[array].push({ label: 'Selecione', id: null });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },

    /*unificarAssociados() {
      this.formUnificacao.cpf = this.form.dadosCliente.cpfcnpj;
      this.formUnificacao.idEmpresa = this.idEmpresa;
      this.$vs.loading();
      service
        .post('admbptech', 'unificarAssociados', this.formUnificacao)
        .then(() => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Associado Unificado com Sucesso',
            color: 'success',
          });
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },*/
    abrirModalHistorico(item) {
      this.dadosConsultaHistorico = [
        {
          tabela: 'associados',
          id: item.idProspect,
        },
      ];
      this.nomeHistorico = item.nome;
      this.popupActive = true;
    },
    fecharModal() {
      this.popupActive = false;
    },
  },
  mounted() {
    this.getDecoded();
    this.$validator.localize('ptBr', locale);
    localStorage.removeItem('formFiltro');
    this.buscaDados();
    this.buscaDadosSelectsPorEmpresa(
      'regionais',
      'regionais',
      'nome',
      'idRegional',
    );
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>
